var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _g, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _g2, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAstronaut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 405,
    height: 490,
    viewBox: "0 0 405 490",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M381.5 458.498C381.5 465.401 380.957 473.998 355 473.998C329.043 473.998 301.5 467.901 301.5 460.998C301.5 454.094 307.543 430.498 333.5 430.498C359.457 430.498 381.5 451.594 381.5 458.498Z",
    fill: "#D21208"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.379,
    cy: 488,
    rx: 7.5,
    ry: 2,
    fill: "#D21208"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M308 464C308 470.904 298.478 474 268.379 474C238.279 474 213.879 468.403 213.879 461.5C213.879 454.596 231.4 439 261.5 439C291.6 439 308 457.097 308 464Z",
    fill: "#D21208"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M359.703 142.575H229.055C225.852 142.618 222.796 143.929 220.557 146.219C218.318 148.51 217.077 151.595 217.106 154.798V292.717C217.073 295.923 218.312 299.011 220.552 301.305C222.792 303.599 225.85 304.911 229.055 304.954H359.758C362.963 304.911 366.021 303.599 368.261 301.305C370.501 299.011 371.74 295.923 371.707 292.717V154.785C371.733 151.574 370.483 148.485 368.232 146.195C365.981 143.906 362.913 142.604 359.703 142.575V142.575Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M371.735 154.922C371.753 153.351 371.461 151.791 370.877 150.333C370.292 148.875 369.426 147.546 368.328 146.422C367.23 145.298 365.921 144.402 364.477 143.784C363.032 143.166 361.48 142.839 359.909 142.821H229.193C226.019 142.857 222.989 144.152 220.769 146.421C218.549 148.69 217.32 151.747 217.353 154.922V292.813C217.335 294.386 217.627 295.947 218.212 297.407C218.797 298.867 219.665 300.197 220.764 301.322C221.863 302.447 223.174 303.344 224.62 303.963C226.066 304.581 227.62 304.909 229.193 304.927H359.895C363.069 304.887 366.098 303.589 368.315 301.317C370.533 299.046 371.758 295.987 371.721 292.813L371.735 154.922Z",
    fill: "url(#paint0_radial_164_14271)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M227.052 153.756L225.062 150.313L227.052 146.855H231.044L233.033 150.313L231.044 153.756H227.052Z",
    fill: "url(#paint1_radial_164_14271)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M357.328 153.756L355.339 150.313L357.328 146.855H361.307L363.296 150.313L361.307 153.756H357.328Z",
    fill: "url(#paint2_radial_164_14271)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M287.1 359.91C287.032 352.227 286.62 344.901 286.236 337.808C285.824 330.139 285.385 322.196 285.385 313.937C285.385 312.181 285.385 310.439 285.454 308.792C285.585 308.734 285.692 308.632 285.756 308.504L285.879 308.353L286.003 308.202H285.811C282.381 307.407 278.334 306.323 274.081 305.171C262.543 302.029 248.206 298.133 237.766 298.133C236.039 298.124 234.314 298.252 232.608 298.517H232.525V298.613C231.785 305.472 231.154 312.675 230.811 319.905V320.001H230.907C253.609 326.497 273.38 340.615 286.894 359.979L287.114 360.308L287.1 359.91Z",
    fill: "#9390A2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M231.112 319.972C231.496 312.769 232.073 305.635 232.813 298.693C234.52 298.426 236.245 298.297 237.972 298.309C252.116 298.309 273.038 305.375 285.989 308.365C285.824 308.557 285.811 308.736 285.55 308.804C285.55 310.547 285.481 312.289 285.481 314.045C285.481 329.891 287.032 343.98 287.182 360.004C273.605 340.655 253.821 326.53 231.112 319.972V319.972Z",
    fill: "url(#paint3_radial_164_14271)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M288.252 447.527C288.252 446.731 288.252 445.894 288.252 445.03C288.236 439.115 287.883 433.207 287.196 427.332C286.401 420.346 286.007 413.319 286.016 406.287C286.016 398.92 286.304 391.457 286.565 384.24C286.825 377.024 287.127 369.575 287.127 362.29C287.127 361.508 287.127 360.74 287.127 359.958C278.762 348.021 267.973 337.984 255.463 330.503C247.825 325.875 239.597 322.299 231.002 319.87H230.865V320.021C230.454 327.539 230.248 335.112 230.248 342.425C230.248 356.295 230.989 366.419 231.62 375.351C232.168 382.992 232.69 390.208 232.69 398.673C232.69 417.88 227.723 428.101 223.731 436.332C220.891 442.19 218.436 447.307 218.436 453.893V453.975C218.436 456.65 218.436 458.955 222.099 460.574C226.008 462.302 234.02 463.112 247.301 463.112C272.612 463.112 282.326 462.44 286.085 458.667C288.335 456.156 288.307 452.726 288.252 447.527Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M232.938 398.601C232.938 380.218 230.496 367.994 230.496 342.353C230.496 334.917 230.715 327.399 231.113 319.95C253.817 326.511 273.596 340.636 287.17 359.982C287.17 360.764 287.17 361.532 287.17 362.301C287.17 377.007 286.072 391.646 286.072 406.366C286.072 424.682 288.295 429.538 288.295 445.096C288.295 460.653 290.887 462.93 247.425 462.93C218.505 462.93 218.684 459.158 218.684 453.835C218.697 437.742 232.938 431.253 232.938 398.601Z",
    fill: "url(#paint4_linear_164_14271)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M288.884 451.328C288.884 450.518 288.788 449.695 288.775 448.872V448.611C287.087 439.625 267.098 430.886 248.152 430.886C239.029 430.886 231.278 432.916 225.763 436.744C219.219 441.285 215.885 448.158 215.885 457.186C215.885 465.897 223.499 466.611 231.977 466.611H237.465C241.69 466.611 245.573 466.611 249.318 466.611C252.487 466.611 255.478 466.611 258.249 466.611C268.95 466.611 276.578 466.268 281.572 464.608C286.772 462.865 289.09 459.655 289.09 454.195C288.994 453.276 288.939 452.288 288.884 451.328Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M288.842 448.966C286.277 431.707 216.131 416.04 216.131 457.197C216.131 467.583 227.216 466.471 237.56 466.471C273.367 466.471 289.062 468.475 289.062 454.275C289.062 452.409 288.842 450.502 288.829 448.623L288.842 448.966Z",
    fill: "url(#paint5_linear_164_14271)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M286.168 414.205C286.058 411.694 286.003 409.115 286.003 406.33C286.003 404.657 286.003 402.901 286.003 400.952V400.87H285.921C279.212 398.126 263.971 395.108 251.006 395.108C239.55 395.108 234.365 396.823 232.54 401.199C232.448 405.467 232.045 409.722 231.333 413.931C231.185 418.417 230.485 422.868 229.247 427.183L229.165 427.471L229.426 427.321C232.897 425.359 237.657 424.398 243.817 424.398C249.971 424.554 256.105 425.15 262.173 426.182C265.544 426.769 268.949 427.145 272.367 427.307C277.594 427.307 277.745 423.795 277.854 420.447C277.978 417.333 278.101 414.411 282.231 414.411H284.467C285.029 414.411 285.51 414.411 285.962 414.411H286.072L286.168 414.205Z",
    fill: "#9390A2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M282.56 414.291C273.807 414.291 282.56 427.256 272.641 427.256C266.811 427.256 254.806 424.333 244.105 424.333C238.618 424.333 233.555 425.074 229.659 427.283C230.89 422.957 231.59 418.498 231.744 414.003C232.456 409.794 232.855 405.539 232.938 401.272C234.625 397.156 239.084 395.249 251.294 395.249C263.504 395.249 278.938 397.993 286.168 400.997C286.168 402.826 286.168 404.624 286.168 406.389C286.168 409.325 286.168 411.876 286.319 414.264C285.866 414.264 285.386 414.264 284.838 414.264L282.56 414.291Z",
    fill: "url(#paint6_linear_164_14271)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M286.813 375.038C277.342 369.996 266.809 367.278 256.082 367.108C247.507 367.074 239.056 369.162 231.483 373.185V373.185L231.621 375.092C231.936 379.524 232.238 383.708 232.444 388.071V388.263L232.622 388.181C239.376 384.594 246.926 382.768 254.573 382.871C264.519 382.871 275.151 385.615 286.209 391.103L286.374 391.185V391.007C286.442 388.784 286.525 386.562 286.607 384.339C286.717 381.293 286.84 378.138 286.936 375.038H286.813Z",
    fill: "#9390A2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M232.691 388.208C232.458 383.241 232.101 378.467 231.73 373.391C255.437 360.783 279.034 371.059 286.95 375.243C286.785 380.566 286.566 385.875 286.388 391.212C259.347 377.685 241.018 383.666 232.691 388.208Z",
    fill: "url(#paint7_linear_164_14271)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M259.923 365.011H250.553C245.81 365.011 241.965 368.856 241.965 373.599V379.828C241.965 384.571 245.81 388.416 250.553 388.416H259.923C264.666 388.416 268.511 384.571 268.511 379.828V373.599C268.511 368.856 264.666 365.011 259.923 365.011Z",
    fill: "#9390A2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M260.101 365.108H250.758C246.007 365.108 242.156 368.959 242.156 373.71V379.925C242.156 384.675 246.007 388.527 250.758 388.527H260.101C264.852 388.527 268.703 384.675 268.703 379.925V373.71C268.703 368.959 264.852 365.108 260.101 365.108Z",
    fill: "url(#paint8_linear_164_14271)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M303.207 359.912C303.276 352.229 303.674 344.903 304.058 337.81C304.469 330.141 304.908 322.198 304.908 313.939C304.908 312.183 304.908 310.441 304.84 308.794C304.712 308.753 304.598 308.677 304.511 308.575C304.48 308.52 304.443 308.47 304.401 308.424L304.277 308.273H304.469C307.885 307.477 311.905 306.394 316.158 305.241C327.751 302.099 342.224 298.203 352.596 298.203C354.328 298.194 356.057 298.322 357.768 298.587H357.851V298.683C358.591 305.543 359.222 312.745 359.565 319.975V320.072H359.469C336.742 326.562 316.943 340.679 303.399 360.049L303.166 360.378L303.207 359.912Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M359.276 319.972C358.879 312.769 358.302 305.635 357.562 298.693C355.86 298.426 354.139 298.297 352.417 298.309C338.245 298.309 317.214 305.375 304.318 308.365C304.482 308.557 304.496 308.736 304.757 308.804C304.757 310.547 304.825 312.289 304.825 314.045C304.825 329.891 303.275 343.98 303.124 360.004C316.727 340.645 336.54 326.519 359.276 319.972Z",
    fill: "url(#paint9_radial_164_14271)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M302.054 447.531C302.054 446.735 302.054 445.898 302.054 445.034C302.067 439.12 302.415 433.211 303.097 427.336C303.899 420.35 304.293 413.323 304.276 406.291C304.276 398.924 304.002 391.461 303.728 384.245C303.453 377.028 303.165 369.579 303.165 362.294C303.165 361.512 303.165 360.744 303.165 359.962C311.525 348.001 322.339 337.96 334.884 330.507C342.535 325.848 350.776 322.235 359.386 319.765H359.537V319.916C359.935 327.434 360.141 335.007 360.141 342.319C360.141 356.189 359.414 366.314 358.769 375.245C358.22 382.886 357.713 390.103 357.713 398.567C357.713 417.774 362.679 427.995 366.671 436.226C369.511 442.084 371.953 447.202 371.953 453.787V453.869C371.953 456.544 371.953 458.849 368.304 460.468C364.394 462.197 356.382 463.006 343.088 463.006C317.666 463.006 307.967 462.334 304.222 458.561C301.972 456.16 302.013 452.731 302.054 447.531Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M357.453 398.601C357.453 380.218 359.895 367.994 359.895 342.353C359.895 334.917 359.675 327.399 359.277 319.95C336.542 326.507 316.733 340.643 303.139 360.009C303.139 360.791 303.139 361.56 303.139 362.328C303.139 377.035 304.25 391.673 304.25 406.394C304.25 424.709 302.027 429.566 302.027 445.123C302.027 460.681 299.435 462.958 342.979 462.958C371.899 462.958 371.789 459.185 371.789 453.862C371.734 437.742 357.453 431.253 357.453 398.601Z",
    fill: "url(#paint10_linear_164_14271)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M301.423 451.328C301.423 450.518 301.519 449.695 301.533 448.872V448.611C303.207 439.625 323.182 430.886 342.224 430.886C351.361 430.886 359.099 432.916 364.627 436.744C371.171 441.285 374.491 448.158 374.491 457.186C374.491 465.897 366.891 466.611 358.413 466.611H352.925C348.7 466.611 344.817 466.611 341.058 466.611C337.875 466.611 334.871 466.611 332.072 466.611C321.344 466.611 313.688 466.268 308.749 464.608C303.81 462.948 301.272 459.655 301.272 454.195C301.314 453.276 301.368 452.288 301.423 451.328Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M301.465 448.966C304.016 431.707 374.245 416.04 374.245 457.197C374.245 467.583 363.16 466.471 352.802 466.471C316.885 466.471 301.231 468.475 301.231 454.275C301.231 452.409 301.451 450.502 301.465 448.623V448.966Z",
    fill: "url(#paint11_linear_164_14271)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M304.125 414.205C304.235 411.694 304.29 409.115 304.29 406.33C304.29 404.657 304.29 402.901 304.29 400.952V400.87H304.372C311.039 398.126 326.323 395.108 339.369 395.108C350.839 395.108 356.011 396.823 357.849 401.199C357.934 405.467 358.338 409.723 359.056 413.931C359.205 418.416 359.901 422.867 361.128 427.183L361.224 427.471L360.963 427.321C357.492 425.359 352.732 424.398 346.572 424.398C340.391 424.554 334.23 425.15 328.133 426.182C324.749 426.769 321.331 427.144 317.899 427.307C312.658 427.307 312.507 423.795 312.411 420.447C312.274 417.333 312.151 414.411 308.049 414.411H305.826C305.264 414.411 304.784 414.411 304.345 414.411H304.221L304.125 414.205Z",
    fill: "#9390A2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M307.762 414.291C316.487 414.291 307.762 427.256 317.653 427.256C323.525 427.256 335.488 424.333 346.326 424.333C351.814 424.333 356.876 425.074 360.773 427.283C359.542 422.957 358.842 418.498 358.687 414.003C357.977 409.794 357.574 405.539 357.48 401.272C355.806 397.156 351.334 395.249 339.124 395.249C326.681 395.249 311.356 397.993 304.168 400.997C304.168 402.794 304.168 404.592 304.168 406.389C304.168 409.325 304.099 411.876 304.003 414.264C304.456 414.264 304.936 414.264 305.485 414.264L307.762 414.291Z",
    fill: "url(#paint12_linear_164_14271)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M303.48 375.038C312.966 369.984 323.52 367.266 334.266 367.108C342.874 367.061 351.359 369.149 358.961 373.186H359.029L358.892 375.093C358.577 379.524 358.275 383.708 358.069 388.071V388.263L357.904 388.181C351.149 384.598 343.6 382.772 335.954 382.872C325.966 382.872 315.375 385.615 304.262 391.103L304.098 391.185V391.007C304.029 388.785 303.947 386.562 303.865 384.339C303.755 381.294 303.645 378.138 303.549 375.038H303.48Z",
    fill: "#9390A2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M357.7 388.208C357.933 383.241 358.304 378.467 358.66 373.391C334.926 360.783 311.233 371.059 303.345 375.243C303.523 380.566 303.729 385.875 303.921 391.212C330.989 377.685 349.372 383.666 357.7 388.208Z",
    fill: "url(#paint13_linear_164_14271)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M352.732 378.528C352.732 369.583 344.94 362.339 335.323 362.339C325.705 362.339 317.927 369.583 317.927 378.528C317.927 387.473 325.719 394.73 335.323 394.73C344.926 394.73 352.732 387.486 352.732 378.528Z",
    fill: "url(#paint14_radial_164_14271)"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M339.439 364.994H330.069C325.318 364.994 321.467 368.845 321.467 373.595V379.824C321.467 384.575 325.318 388.426 330.069 388.426H339.439C344.19 388.426 348.041 384.575 348.041 379.824V373.595C348.041 368.845 344.19 364.994 339.439 364.994Z",
    fill: "#9390A2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M339.644 365.09H330.26C325.509 365.09 321.658 368.942 321.658 373.692V379.935C321.658 384.685 325.509 388.536 330.26 388.536H339.644C344.395 388.536 348.246 384.685 348.246 379.935V373.692C348.246 368.942 344.395 365.09 339.644 365.09Z",
    fill: "url(#paint15_linear_164_14271)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M259.642 366.531H251.424C247.257 366.531 243.879 369.909 243.879 374.077V379.537C243.879 383.704 247.257 387.082 251.424 387.082H259.642C263.809 387.082 267.188 383.704 267.188 379.537V374.077C267.188 369.909 263.809 366.531 259.642 366.531Z",
    fill: "url(#paint16_linear_164_14271)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M339.628 366.547H331.411C327.251 366.547 323.879 369.919 323.879 374.079V379.539C323.879 383.699 327.251 387.071 331.411 387.071H339.628C343.788 387.071 347.16 383.699 347.16 379.539V374.079C347.16 369.919 343.788 366.547 339.628 366.547Z",
    fill: "url(#paint17_linear_164_14271)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M344.034 157.804H246.916C237.816 157.804 230.439 165.18 230.439 174.28V274.279C230.439 283.379 237.816 290.756 246.916 290.756H344.034C353.134 290.756 360.511 283.379 360.511 274.279V174.28C360.511 165.18 353.134 157.804 344.034 157.804Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M344.241 158.015H247.095C238.064 158.015 230.742 165.337 230.742 174.368V274.381C230.742 283.412 238.064 290.734 247.095 290.734H344.241C353.272 290.734 360.594 283.412 360.594 274.381V174.368C360.594 165.337 353.272 158.015 344.241 158.015Z",
    fill: "url(#paint18_linear_164_14271)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M300.833 174.275H290.229V294.44H300.833V174.275Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M301.081 294.551H289.969V174.125H301.081V294.551ZM290.476 294.304H300.574V174.385H290.476V294.304Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M301.245 174.363H290.64V294.529H301.245V174.363Z",
    fill: "url(#paint19_linear_164_14271)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M231.373 294.213V302.526H231.455C254.613 308.741 272.352 322.831 278.992 340.199C279.711 342.031 280.963 343.605 282.588 344.716C284.213 345.827 286.134 346.423 288.102 346.428H302.575C304.536 346.42 306.448 345.821 308.063 344.71C309.679 343.599 310.921 342.027 311.63 340.199C318.284 322.831 336.105 308.741 359.304 302.526H359.386V294.213H231.373Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M359.66 294.521V302.629C336.516 308.816 318.599 322.878 311.904 340.37C311.209 342.18 309.982 343.737 308.386 344.836C306.789 345.936 304.897 346.526 302.959 346.53H288.485C286.54 346.535 284.639 345.948 283.034 344.848C281.429 343.748 280.197 342.186 279.499 340.37C272.804 322.878 254.956 308.816 231.866 302.629V294.521H359.66Z",
    fill: "url(#paint20_linear_164_14271)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M359.66 294.521V302.629C336.516 308.816 318.599 322.878 311.904 340.37C311.209 342.18 309.982 343.737 308.386 344.836C306.789 345.936 304.897 346.526 302.959 346.53H288.485C286.54 346.535 284.639 345.948 283.034 344.848C281.429 343.748 280.197 342.186 279.499 340.37C272.804 322.878 254.956 308.816 231.866 302.629V294.521H359.66Z",
    fill: "url(#paint21_linear_164_14271)",
    fillOpacity: 0.4
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M359.386 282.436H231.564V296.361H359.386V282.436Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M359.468 282.648H231.88V296.34H359.468V282.648Z",
    fill: "url(#paint22_linear_164_14271)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M359.468 282.648H231.88V296.34H359.468V282.648Z",
    fill: "url(#paint23_linear_164_14271)",
    fillOpacity: 0.2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M342.774 230.531H244.064V237.336H342.774V230.531Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M342.841 230.742H244.379V237.314H342.841V230.742Z",
    fill: "url(#paint24_linear_164_14271)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M345.078 164.639H335.008V296.658H345.078V164.639Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M345.132 164.868H335.31V296.64H345.132V164.868Z",
    fill: "url(#paint25_linear_164_14271)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M344.983 222.41H335.077C334.612 222.465 334.187 222.7 333.893 223.064C333.598 223.427 333.457 223.892 333.5 224.358V229.626C333.48 229.899 333.566 230.17 333.739 230.382C333.913 230.593 334.161 230.731 334.433 230.765H337.437C337.645 230.796 337.832 230.906 337.96 231.072C338.088 231.239 338.147 231.448 338.123 231.657V236.417C338.104 236.639 338.172 236.859 338.313 237.031C338.454 237.202 338.657 237.312 338.878 237.336H341.21C341.32 237.326 341.427 237.294 341.525 237.242C341.622 237.19 341.709 237.12 341.779 237.034C341.849 236.949 341.901 236.85 341.933 236.744C341.965 236.638 341.976 236.527 341.964 236.417V231.657C341.941 231.446 342.001 231.235 342.132 231.068C342.263 230.901 342.454 230.792 342.664 230.765H345.669C345.943 230.734 346.194 230.598 346.371 230.386C346.547 230.174 346.635 229.902 346.615 229.626V224.358C346.636 224.123 346.61 223.886 346.539 223.661C346.468 223.436 346.354 223.227 346.202 223.046C346.051 222.865 345.865 222.716 345.656 222.607C345.446 222.498 345.218 222.431 344.983 222.41V222.41Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M346.629 224.464C346.675 224.029 346.548 223.594 346.276 223.253C346.004 222.911 345.608 222.691 345.174 222.639H335.283C334.847 222.687 334.447 222.907 334.172 223.248C333.897 223.59 333.769 224.027 333.815 224.464V229.732C333.788 229.974 333.858 230.217 334.01 230.407C334.161 230.597 334.383 230.72 334.624 230.747H337.615C337.855 230.778 338.074 230.901 338.225 231.091C338.376 231.28 338.448 231.521 338.425 231.762V236.523C338.405 236.712 338.46 236.901 338.578 237.049C338.696 237.198 338.867 237.295 339.056 237.319H341.388C341.579 237.298 341.753 237.203 341.874 237.054C341.995 236.904 342.052 236.714 342.033 236.523V231.749C342.006 231.507 342.076 231.264 342.227 231.074C342.379 230.883 342.6 230.761 342.842 230.733H345.819C346.061 230.706 346.282 230.583 346.434 230.393C346.586 230.203 346.656 229.96 346.629 229.718V224.464Z",
    fill: "#E1E0E1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M254.093 164.639H244.064V296.658H254.093V164.639Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M254.174 164.868H244.379V296.64H254.174V164.868Z",
    fill: "url(#paint26_linear_164_14271)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M254.01 222.41H244.146C243.681 222.465 243.256 222.7 242.961 223.064C242.666 223.427 242.525 223.892 242.568 224.358V229.626C242.545 229.898 242.627 230.168 242.798 230.381C242.97 230.593 243.217 230.731 243.487 230.765H246.478C246.686 230.796 246.873 230.906 247.001 231.072C247.129 231.239 247.188 231.448 247.164 231.657V236.417C247.145 236.639 247.213 236.859 247.354 237.031C247.495 237.202 247.698 237.312 247.918 237.336H250.251C250.471 237.312 250.672 237.202 250.811 237.03C250.95 236.858 251.015 236.637 250.992 236.417V231.657C250.968 231.446 251.028 231.235 251.159 231.068C251.29 230.901 251.481 230.792 251.691 230.765H254.655C254.925 230.731 255.172 230.593 255.343 230.381C255.515 230.168 255.597 229.898 255.574 229.626V224.358C255.617 223.894 255.477 223.431 255.186 223.068C254.894 222.704 254.472 222.469 254.01 222.41Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M255.657 224.464C255.699 224.03 255.571 223.597 255.3 223.256C255.028 222.916 254.635 222.694 254.202 222.639H244.325C243.892 222.694 243.499 222.916 243.227 223.256C242.956 223.597 242.828 224.03 242.87 224.464V229.732C242.847 229.973 242.918 230.214 243.07 230.403C243.221 230.593 243.439 230.716 243.68 230.747H246.671C246.912 230.775 247.133 230.897 247.285 231.087C247.437 231.278 247.507 231.52 247.48 231.762V236.523C247.461 236.712 247.516 236.901 247.634 237.049C247.752 237.198 247.923 237.295 248.111 237.319H250.443C250.632 237.295 250.803 237.198 250.921 237.049C251.039 236.901 251.094 236.712 251.074 236.523V231.749C251.047 231.509 251.115 231.268 251.264 231.078C251.413 230.888 251.631 230.764 251.87 230.733H254.847C255.088 230.702 255.306 230.579 255.458 230.39C255.609 230.2 255.68 229.959 255.657 229.718V224.464Z",
    fill: "url(#paint27_linear_164_14271)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M309.064 280.428H281.777C280.75 280.426 279.733 280.627 278.783 281.018C277.834 281.41 276.971 281.984 276.243 282.709C275.516 283.434 274.939 284.295 274.544 285.243C274.149 286.191 273.945 287.208 273.943 288.234V296.466C273.947 298.541 274.774 300.53 276.243 301.996C277.711 303.462 279.702 304.286 281.777 304.286H309.064C311.137 304.282 313.124 303.457 314.59 301.991C316.056 300.526 316.881 298.539 316.884 296.466V288.234C316.881 286.163 316.055 284.177 314.589 282.714C313.123 281.25 311.136 280.428 309.064 280.428V280.428Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M309.256 280.657H282.037C277.787 280.657 274.341 284.103 274.341 288.354V296.64C274.341 300.891 277.787 304.336 282.037 304.336H309.256C313.507 304.336 316.952 300.891 316.952 296.64V288.354C316.952 284.103 313.507 280.657 309.256 280.657Z",
    fill: "url(#paint28_linear_164_14271)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M309.256 280.657H282.037C277.787 280.657 274.341 284.103 274.341 288.354V296.64C274.341 300.891 277.787 304.336 282.037 304.336H309.256C313.507 304.336 316.952 300.891 316.952 296.64V288.354C316.952 284.103 313.507 280.657 309.256 280.657Z",
    fill: "url(#paint29_linear_164_14271)",
    fillOpacity: 0.2
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M348.219 152.759C347.595 152.276 346.827 152.016 346.038 152.018C345.411 152.023 344.794 152.185 344.246 152.489C343.697 152.794 343.233 153.231 342.896 153.76C342.773 153.952 330.179 172.473 294.756 172.473C259.717 172.473 250.567 154.954 250.196 154.213C249.9 153.562 249.426 153.009 248.829 152.616C248.232 152.223 247.536 152.006 246.821 151.99C246.206 151.992 245.601 152.153 245.065 152.457C244.144 153.018 243.464 153.902 243.16 154.937C242.855 155.972 242.948 157.084 243.419 158.054C243.858 158.973 254.682 180.773 294.756 180.773C334.541 180.773 348.604 159.412 349.18 158.507C349.754 157.598 349.973 156.51 349.796 155.45C349.618 154.39 349.057 153.432 348.219 152.759V152.759Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M294.907 180.743C254.902 180.743 244.146 159.012 243.68 158.093C243.204 157.157 243.103 156.075 243.399 155.067C243.695 154.06 244.365 153.204 245.271 152.674C245.704 152.437 246.182 152.292 246.675 152.25C247.167 152.208 247.662 152.269 248.13 152.429C248.597 152.589 249.026 152.845 249.389 153.18C249.752 153.515 250.041 153.922 250.237 154.375C250.635 155.171 259.841 172.704 294.907 172.704C330.467 172.704 343.02 154.128 343.143 153.95C343.4 153.527 343.743 153.162 344.15 152.88C344.556 152.597 345.017 152.403 345.503 152.31C345.989 152.217 346.49 152.227 346.972 152.339C347.454 152.452 347.907 152.664 348.302 152.962C349.117 153.612 349.663 154.54 349.836 155.568C350.008 156.596 349.794 157.652 349.235 158.532C348.7 159.437 334.692 180.743 294.907 180.743Z",
    fill: "url(#paint30_radial_164_14271)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M294.907 180.743C254.902 180.743 244.146 159.012 243.68 158.093C243.204 157.157 243.103 156.075 243.399 155.067C243.695 154.06 244.365 153.204 245.271 152.674C245.704 152.437 246.182 152.292 246.675 152.25C247.167 152.208 247.662 152.269 248.13 152.429C248.597 152.589 249.026 152.845 249.389 153.18C249.752 153.515 250.041 153.922 250.237 154.375C250.635 155.171 259.841 172.704 294.907 172.704C330.467 172.704 343.02 154.128 343.143 153.95C343.4 153.527 343.743 153.162 344.15 152.88C344.556 152.597 345.017 152.403 345.503 152.31C345.989 152.217 346.49 152.227 346.972 152.339C347.454 152.452 347.907 152.664 348.302 152.962C349.117 153.612 349.663 154.54 349.836 155.568C350.008 156.596 349.794 157.652 349.235 158.532C348.7 159.437 334.692 180.743 294.907 180.743Z",
    fill: "url(#paint31_linear_164_14271)",
    fillOpacity: 0.2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M359.263 82.714C359.286 82.0867 359.059 81.4761 358.632 81.0159C358.205 80.5557 357.613 80.2832 356.986 80.2582H343.267V100.768C342.927 102.697 342.698 104.644 342.581 106.599C342.347 110.363 342.577 114.141 343.267 117.849V134.682H355.971C356.876 134.643 357.729 134.247 358.343 133.581C358.957 132.916 359.283 132.034 359.25 131.129V131.129C364.106 127.603 367.893 118.782 368.483 108.341C369.21 95.9255 365.204 85.2246 359.263 82.714Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M230.55 82.714C230.537 82.404 230.586 82.0946 230.693 81.8034C230.799 81.5121 230.963 81.2448 231.173 81.0168C231.383 80.7887 231.636 80.6043 231.918 80.4741C232.199 80.344 232.504 80.2706 232.814 80.2582H246.533V100.755C246.878 102.687 247.107 104.639 247.219 106.599C247.453 110.363 247.223 114.141 246.533 117.849V134.682H233.843C232.938 134.643 232.085 134.247 231.471 133.581C230.857 132.916 230.531 132.034 230.564 131.129C225.694 127.603 221.921 118.782 221.317 108.341C220.59 95.9255 224.61 85.2246 230.55 82.714Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M360.114 83.5772C360.127 83.2673 360.078 82.9578 359.972 82.6666C359.865 82.3754 359.702 82.1081 359.491 81.88C359.281 81.6519 359.028 81.4675 358.746 81.3373C358.465 81.2072 358.16 81.1338 357.85 81.1215H344.131V101.618C343.785 103.55 343.556 105.502 343.445 107.462C343.211 111.226 343.441 115.004 344.131 118.712V135.545H356.821C357.726 135.506 358.579 135.11 359.193 134.445C359.808 133.779 360.134 132.897 360.1 131.992C364.971 128.453 368.743 119.645 369.347 109.205C370.074 96.7201 366.054 86.0604 360.114 83.5772Z",
    fill: "url(#paint32_linear_164_14271)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M231.415 83.5772C231.402 83.2673 231.45 82.9578 231.557 82.6666C231.664 82.3754 231.827 82.1081 232.037 81.88C232.247 81.6519 232.501 81.4675 232.782 81.3373C233.064 81.2072 233.368 81.1338 233.678 81.1215H247.397V101.618C248.413 107.271 248.413 113.059 247.397 118.712V135.545H234.707C233.8 135.506 232.945 135.109 232.33 134.44C231.715 133.771 231.391 132.886 231.428 131.978C226.558 128.453 222.785 119.631 222.182 109.205C221.454 96.7201 225.474 86.0604 231.415 83.5772Z",
    fill: "url(#paint33_linear_164_14271)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M242.773 52.0168C242.844 50.124 242.161 48.2803 240.876 46.8893C239.59 45.4983 237.806 44.6732 235.913 44.5947H232.484C230.591 44.6732 228.807 45.4983 227.521 46.8893C226.236 48.2803 225.554 50.124 225.624 52.0168V85.4229C225.554 87.3143 226.236 89.1565 227.522 90.5453C228.808 91.9342 230.592 92.7562 232.484 92.8312H235.913C237.805 92.7562 239.589 91.9342 240.875 90.5453C242.161 89.1565 242.844 87.3143 242.773 85.4229V52.0168Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M243.693 52.8976C243.764 51.0048 243.082 49.1611 241.796 47.7701C240.511 46.3791 238.726 45.5541 236.834 45.4756H233.404C231.51 45.5505 229.724 46.3745 228.438 47.7663C227.151 49.1581 226.47 51.0039 226.545 52.8976V86.3174C226.47 88.2112 227.151 90.0569 228.438 91.4488C229.724 92.8406 231.51 93.6646 233.404 93.7395H236.834C238.726 93.661 240.511 92.8359 241.796 91.4449C243.082 90.0539 243.764 88.2102 243.693 86.3174V52.8976Z",
    fill: "url(#paint34_linear_164_14271)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M240.442 57.5077C240.346 56.3249 239.907 55.1957 239.18 54.2582C238.452 53.3208 237.467 52.6157 236.345 52.2293C235.223 51.8429 234.012 51.7919 232.862 52.0825C231.711 52.3732 230.67 52.9928 229.866 53.8658C229.062 54.7387 228.53 55.827 228.335 56.9975C228.14 58.1681 228.29 59.3702 228.767 60.4567C229.245 61.5432 230.028 62.4671 231.022 63.1154C232.016 63.7636 233.178 64.1081 234.364 64.1066C236.045 64.0353 237.628 63.3006 238.767 62.0635C239.907 60.8265 240.509 59.1881 240.442 57.5077Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M241.031 57.8561C240.938 56.673 240.501 55.5428 239.776 54.6036C239.05 53.6645 238.067 52.9573 236.945 52.5684C235.824 52.1795 234.614 52.1258 233.463 52.4139C232.311 52.7021 231.269 53.3195 230.463 54.1907C229.657 55.0619 229.123 56.1491 228.925 57.3193C228.727 58.4895 228.875 59.692 229.35 60.7795C229.825 61.8671 230.607 62.7927 231.599 63.4431C232.592 64.0934 233.753 64.4403 234.94 64.4413C236.619 64.3699 238.201 63.6375 239.342 62.4039C240.483 61.1703 241.09 59.5355 241.031 57.8561V57.8561Z",
    fill: "url(#paint35_radial_164_14271)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M360.869 104.22C360.869 63.172 331.757 29.9031 295.277 29.9031C258.798 29.9031 228.932 63.172 228.932 104.22C228.932 145.267 258.839 172.445 295.277 172.445C331.715 172.445 360.869 145.308 360.869 104.22Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M361.733 105.043C361.733 64.0087 332.621 30.7398 296.155 30.7398C259.69 30.7398 229.796 64.0087 229.796 105.043C229.796 146.077 259.704 173.282 296.155 173.282C332.607 173.282 361.733 146.09 361.733 105.043Z",
    fill: "url(#paint36_linear_164_14271)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M309.613 23.5218C309.321 22.7299 308.797 22.0445 308.109 21.555C307.421 21.0656 306.602 20.7948 305.758 20.778H284C283.154 20.7958 282.334 21.0668 281.644 21.5559C280.954 22.0451 280.427 22.7299 280.131 23.5218L277.62 30.0659C277.353 30.7582 277.247 31.5026 277.311 32.2421C277.375 32.9816 277.608 33.6966 277.991 34.3325C278.348 34.9415 278.857 35.4482 279.467 35.8038C280.077 36.1594 280.769 36.352 281.475 36.3629H308.269C308.975 36.352 309.667 36.1594 310.277 35.8038C310.887 35.4482 311.396 34.9415 311.753 34.3325C312.138 33.6976 312.373 32.9832 312.44 32.2437C312.506 31.5042 312.403 30.7593 312.138 30.0659L309.613 23.5218Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M310.492 24.3586C310.196 23.5666 309.668 22.8818 308.979 22.3926C308.289 21.9035 307.468 21.6325 306.623 21.6147H284.864C284.019 21.6306 283.197 21.9009 282.507 22.3903C281.817 22.8797 281.29 23.5656 280.996 24.3586L278.444 30.9026C278.178 31.596 278.075 32.341 278.142 33.0805C278.208 33.8199 278.443 34.5344 278.828 35.1693C279.186 35.7783 279.694 36.285 280.305 36.6406C280.915 36.9962 281.606 37.1887 282.313 37.1997H309.106C309.812 37.1887 310.504 36.9962 311.114 36.6406C311.725 36.285 312.233 35.7783 312.591 35.1693C312.976 34.5344 313.211 33.8199 313.277 33.0805C313.344 32.341 313.24 31.596 312.975 30.9026L310.492 24.3586Z",
    fill: "url(#paint37_linear_164_14271)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M302.809 26.2456C302.663 25.8486 302.4 25.5051 302.054 25.2603C301.709 25.0155 301.298 24.8807 300.875 24.8737H290.009C289.587 24.8826 289.176 25.0181 288.832 25.2627C288.487 25.5072 288.223 25.8497 288.075 26.2456L286.827 29.6343C286.691 29.995 286.637 30.3813 286.668 30.7654C286.698 31.1496 286.814 31.5222 287.005 31.8568C287.179 32.1673 287.432 32.4269 287.737 32.6097C288.043 32.7926 288.391 32.8925 288.747 32.8994H302.137C302.492 32.8942 302.839 32.795 303.142 32.6118C303.446 32.4286 303.696 32.168 303.866 31.8568C304.062 31.5243 304.181 31.152 304.214 30.7674C304.248 30.3827 304.194 29.9955 304.058 29.6343L302.809 26.2456Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M303.002 26.915C302.86 26.5201 302.602 26.1776 302.261 25.9326C301.921 25.6876 301.514 25.5518 301.095 25.5431H290.394C289.974 25.5499 289.566 25.685 289.225 25.9302C288.884 26.1754 288.627 26.5191 288.487 26.915L287.252 30.1253C287.119 30.4661 287.067 30.8331 287.101 31.1974C287.134 31.5617 287.252 31.9133 287.444 32.2243C287.619 32.525 287.869 32.7753 288.17 32.9507C288.47 33.1262 288.811 33.221 289.159 33.2258H302.329C302.677 33.2184 303.017 33.1225 303.317 32.9473C303.617 32.772 303.867 32.5232 304.044 32.2243C304.235 31.9122 304.35 31.5601 304.381 31.1958C304.412 30.8315 304.357 30.4651 304.223 30.1253L303.002 26.915Z",
    fill: "url(#paint38_linear_164_14271)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_164_14271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.879 102C357.879 67.7598 330.568 40 296.277 40C261.986 40 233.879 67.7598 233.879 102C233.879 136.24 262.001 164 296.277 164C330.553 164 357.879 136.255 357.879 102Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M246.985 197.814C251.293 181.022 246.656 165.313 236.6 162.734C226.544 160.155 214.924 171.679 210.602 188.471C206.281 205.263 210.945 220.985 220.988 223.565C231.03 226.144 242.678 214.62 246.985 197.814Z",
    fill: "url(#paint39_radial_164_14271)"
  }), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M319.367 195.458H269.224C266.565 195.469 264.019 196.533 262.145 198.418C260.27 200.304 259.219 202.855 259.223 205.514V233.117C259.219 235.775 260.27 238.327 262.145 240.212C264.019 242.097 266.565 243.162 269.224 243.173H319.367C322.033 243.169 324.589 242.109 326.474 240.224C328.359 238.338 329.42 235.783 329.424 233.117V205.514C329.42 202.848 328.359 200.292 326.474 198.407C324.589 196.522 322.033 195.461 319.367 195.458Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M299.804 222.58V196.074H269.704C267.169 196.092 264.744 197.112 262.957 198.911C261.171 200.71 260.169 203.143 260.169 205.678V233.294C260.169 235.829 261.171 238.262 262.957 240.061C264.744 241.86 267.169 242.88 269.704 242.898H284.658V222.58H299.804Z",
    fill: "#EDEDED"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M319.848 196.074H299.804V222.525H284.713V242.843H319.902C322.449 242.843 324.892 241.831 326.693 240.03C328.494 238.229 329.506 235.787 329.506 233.24V205.678C329.506 204.412 329.256 203.159 328.77 201.99C328.284 200.821 327.571 199.76 326.674 198.868C325.776 197.975 324.711 197.269 323.54 196.79C322.368 196.31 321.113 196.067 319.848 196.074Z",
    fill: "#C6C6C6"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M278.169 206.063C276.852 206.068 275.565 206.464 274.473 207.2C273.38 207.936 272.529 208.979 272.029 210.198C271.529 211.416 271.4 212.756 271.661 214.048C271.921 215.339 272.558 216.525 273.492 217.454C274.425 218.384 275.613 219.016 276.906 219.271C278.199 219.526 279.538 219.393 280.755 218.887C281.971 218.382 283.011 217.527 283.742 216.432C284.474 215.336 284.864 214.048 284.864 212.73C284.866 211.852 284.694 210.982 284.358 210.17C284.022 209.359 283.528 208.622 282.906 208.002C282.283 207.382 281.544 206.891 280.731 206.559C279.919 206.226 279.048 206.057 278.169 206.063V206.063Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M314.401 209.633C314.401 208.697 314.123 207.782 313.603 207.003C313.083 206.225 312.344 205.618 311.479 205.26C310.614 204.902 309.662 204.808 308.744 204.991C307.826 205.173 306.983 205.624 306.321 206.286C305.659 206.948 305.208 207.791 305.026 208.71C304.843 209.628 304.937 210.579 305.295 211.444C305.653 212.309 306.26 213.048 307.038 213.568C307.816 214.088 308.732 214.366 309.668 214.366C310.922 214.362 312.124 213.863 313.01 212.976C313.897 212.089 314.397 210.887 314.401 209.633V209.633Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M312.33 219.274C311.394 219.274 310.479 219.552 309.7 220.072C308.922 220.592 308.315 221.331 307.957 222.196C307.599 223.061 307.505 224.013 307.688 224.931C307.87 225.849 308.321 226.692 308.983 227.354C309.645 228.016 310.488 228.467 311.406 228.65C312.325 228.832 313.276 228.739 314.141 228.38C315.006 228.022 315.745 227.415 316.265 226.637C316.785 225.859 317.063 224.944 317.063 224.008C317.059 222.753 316.559 221.552 315.673 220.665C314.786 219.778 313.584 219.278 312.33 219.274V219.274Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M284.713 212.81C284.716 211.537 284.341 210.293 283.637 209.233C282.932 208.173 281.929 207.347 280.754 206.857C279.579 206.368 278.286 206.237 277.037 206.483C275.789 206.729 274.641 207.339 273.739 208.237C272.837 209.135 272.222 210.28 271.971 211.528C271.72 212.775 271.845 214.069 272.329 215.246C272.814 216.423 273.636 217.429 274.693 218.139C275.75 218.848 276.993 219.228 278.265 219.231C279.111 219.234 279.949 219.071 280.731 218.75C281.513 218.429 282.224 217.956 282.823 217.36C283.422 216.763 283.898 216.054 284.222 215.273C284.546 214.493 284.713 213.655 284.713 212.81Z",
    fill: "url(#paint40_radial_164_14271)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M314.251 209.796C314.251 208.905 313.986 208.035 313.491 207.295C312.996 206.554 312.293 205.978 311.47 205.637C310.647 205.297 309.741 205.209 308.868 205.384C307.995 205.558 307.193 205.988 306.564 206.619C305.935 207.25 305.508 208.053 305.336 208.927C305.164 209.8 305.255 210.706 305.597 211.528C305.94 212.35 306.519 213.051 307.261 213.544C308.003 214.037 308.874 214.299 309.765 214.296C310.355 214.296 310.939 214.179 311.485 213.953C312.03 213.727 312.525 213.395 312.942 212.977C313.358 212.559 313.689 212.063 313.913 211.517C314.138 210.971 314.253 210.386 314.251 209.796V209.796Z",
    fill: "url(#paint41_radial_164_14271)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M316.926 224.114C316.929 223.223 316.668 222.352 316.175 221.61C315.682 220.868 314.98 220.29 314.158 219.947C313.336 219.604 312.431 219.513 311.557 219.685C310.683 219.857 309.88 220.285 309.25 220.913C308.619 221.542 308.189 222.344 308.014 223.217C307.839 224.091 307.928 224.996 308.268 225.819C308.608 226.642 309.185 227.346 309.925 227.841C310.665 228.336 311.536 228.6 312.427 228.6C313.618 228.6 314.76 228.128 315.604 227.287C316.447 226.446 316.923 225.305 316.926 224.114V224.114Z",
    fill: "url(#paint42_radial_164_14271)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M185.88 214.637C185.88 214.637 180.57 222.237 175.165 223.87C175.165 223.87 188.143 241.087 185.592 253.421C185.592 253.421 193.343 257.852 203.33 245.381C213.318 232.911 216.775 227.711 213.592 220.605C210.41 213.498 195.853 204.306 185.88 214.637Z",
    fill: "url(#paint43_radial_164_14271)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M156.782 209.365H156.713C154.05 209.549 151.487 210.45 149.296 211.975C147.104 213.499 145.368 215.589 144.27 218.022C144.213 218.381 144.181 218.743 144.174 219.106C144.134 219.568 144.195 220.034 144.354 220.47C144.513 220.906 144.765 221.302 145.093 221.63C145.762 222.124 146.582 222.367 147.412 222.316V222.316C148.929 222.229 150.433 221.98 151.898 221.576C153.054 221.25 154.24 221.043 155.437 220.958V220.958C156.623 221.138 157.744 221.61 158.703 222.33C159.632 222.975 160.707 223.381 161.831 223.51V223.51C163.71 223.51 164.574 220.848 164.574 219.051C164.67 214.442 162.228 209.407 156.782 209.365Z",
    fill: "#9390A2"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M144.572 218.129C145.663 215.718 147.388 213.649 149.562 212.142C151.737 210.634 154.279 209.745 156.919 209.568C162.242 209.568 164.698 214.617 164.657 219.172C164.657 220.9 163.779 223.534 161.913 223.52C160.047 223.507 157.701 220.941 155.589 220.928C153.476 220.914 150.032 222.299 147.481 222.299C145.67 222.299 144.353 221.586 144.366 219.199C144.49 218.87 144.531 218.527 144.572 218.129Z",
    fill: "url(#paint44_linear_164_14271)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M209.326 184.75C205.869 182.98 203.139 181.581 202.467 181.101H202.371L202.302 181.197C200.886 183.609 199.71 186.155 198.79 188.797C197.94 190.951 197.062 193.187 196.197 194.875C197.844 205.452 206.102 209.966 212.756 213.574C216.515 215.632 219.753 217.402 220.988 219.816L221.084 220.008L221.194 219.816C225.529 212.957 232.869 200.829 232.882 199.237C232.827 196.974 221.221 190.841 209.326 184.75Z",
    fill: "#9390A2"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M202.577 181.294C200.574 184.148 198.543 190.898 196.472 195.014C199.037 211.477 217.901 213.178 221.166 219.914C226.654 211.079 232.814 200.707 232.827 199.335C232.91 196.07 205.046 183.051 202.577 181.294Z",
    fill: "url(#paint45_radial_164_14271)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M221.139 219.727C219.767 216.983 215.981 213.814 211.536 210.123C205.293 204.965 198.228 199.148 196.719 192.906V192.604L196.568 192.892C190.943 203.867 185.003 215.076 179.625 220.769L179.364 221.044L179.735 220.961C180.658 220.685 181.543 220.294 182.369 219.795C184.193 218.605 186.288 217.893 188.46 217.724C188.837 217.724 189.213 217.751 189.585 217.806C200.643 219.672 204.909 224.666 204.827 235.641C204.827 242.953 196.595 251.445 191.026 253.586L191.094 253.819C201.479 251.953 209.066 239.523 217.16 226.38C218.532 224.24 219.904 222.004 221.276 219.809L221.139 219.727Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M196.842 193.088C191.519 203.487 185.345 215.204 179.885 220.993C182.052 220.554 185.592 217.138 189.763 217.838C201.149 219.745 205.197 224.972 205.114 235.796C205.114 243.52 196.471 251.82 191.23 253.85C203.262 251.697 211.425 235.453 221.221 219.882C217.901 213.146 199.407 203.611 196.842 193.088Z",
    fill: "url(#paint46_radial_164_14271)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M190.284 225.462C188.141 223.321 185.56 221.668 182.718 220.617C179.877 219.565 176.842 219.14 173.821 219.371C168.868 219.631 160.788 221.84 154.175 224.748C149.483 226.806 141.622 230.95 141.595 235.545C141.595 235.683 141.595 236.012 141.499 236.465C141.101 239.716 139.907 249.608 144.613 254.958C145.688 256.12 147.003 257.032 148.468 257.632C149.933 258.232 151.511 258.504 153.092 258.429H155.108C156.823 258.429 158.607 258.429 160.5 258.429C177.772 258.429 197.61 256.769 197.72 243.955C197.688 237.069 195.028 230.454 190.284 225.462V225.462Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M173.959 219.584C190.422 218.72 197.816 233.454 197.734 244.1C197.611 259.465 168.608 258.505 153.215 258.395C137.823 258.285 141.842 237.172 141.842 235.635C141.911 228.049 164.451 220.078 173.959 219.584Z",
    fill: "url(#paint47_linear_164_14271)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M241.252 170.012C235.961 166.618 229.85 164.722 223.568 164.524C214.993 164.524 207.873 168.832 202.427 177.297C198.119 184.005 197.57 190.398 200.794 196.311C206.199 206.23 220.755 211.581 225.488 211.581C225.967 211.61 226.443 211.501 226.86 211.265C230.729 205.839 234.231 200.161 237.342 194.267C243.707 182.098 244.983 173.99 241.252 170.012Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M241.403 170.258C241.403 170.258 217.902 153.795 202.756 177.405C187.61 201.016 223.952 213.61 227.094 211.209C227.066 211.168 250.224 179.614 241.403 170.258Z",
    fill: "url(#paint48_radial_164_14271)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M210.521 175.054L220.865 179.54L221.194 178.785L210.836 174.299L210.521 175.054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M211.506 172.751L211.179 173.507L221.525 177.993L221.853 177.237L211.506 172.751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M209.848 176.595L220.192 181.081L220.521 180.327L210.177 175.841L209.848 176.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M211.85 171.983L211.507 172.765L221.851 177.251L222.194 176.469L211.85 171.983Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M210.834 174.297L221.192 178.784L221.535 178.002L211.177 173.515L210.834 174.297Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M210.498 175.025L210.159 175.805L220.506 180.291L220.844 179.511L210.498 175.025Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M209.854 176.624L209.51 177.417L219.855 181.905L220.199 181.112L209.854 176.624Z",
    fill: "#E30613"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M222.182 176.484L218.889 175.057L217.888 177.348L221.18 178.775L222.182 176.484Z",
    fill: "#5A2045"
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M385.028 183.171V183.047L357.891 191.663H357.768V191.773C368.464 221.834 373.854 253.526 373.695 285.433V285.543L395.742 286.393V286.27C398.163 251.543 394.537 216.658 385.028 183.171V183.171Z",
    fill: "#736E86"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M385.11 183.294L358.083 191.868C368.761 221.949 374.15 253.651 374.011 285.57L395.824 286.393C398.234 251.666 394.609 216.784 385.11 183.294Z",
    fill: "url(#paint49_linear_164_14271)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M396.126 222.89C396.03 222.328 395.948 221.875 395.907 221.519C395.715 220.147 395.536 218.775 395.372 217.485C394.521 210.914 393.712 204.699 391.434 201.2C391.434 201.063 391.228 200.995 390.982 201.008C388.238 201.077 371.281 210.077 365.587 216.758C363.31 220.49 368.564 242.536 370.293 249.794C371.619 250.229 373.021 250.379 374.409 250.233C379.896 250.082 390.337 248.326 394.988 242.646C398.733 238.283 396.908 227.5 396.126 222.89Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M365.876 216.938C372.118 209.626 391.009 200.05 391.517 201.367C394.261 205.579 394.864 213.714 395.976 221.658C396.387 224.511 399.268 237.778 395.18 242.758C388.979 250.344 372.2 250.989 370.609 249.878C368.112 239.424 363.791 220.368 365.876 216.938Z",
    fill: "url(#paint50_linear_164_14271)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M396.566 245.122L396.497 244.985L396.387 245.095C394.22 247.015 388.156 250.116 371.693 254.012L370.705 254.245H370.636V254.314C370.636 256.166 370.335 258.745 370.047 261.462C369.565 265.17 369.313 268.904 369.292 272.643C369.429 277.993 371.377 283.33 375.397 283.22C386.537 282.932 393.232 281.546 396.483 278.899C399.474 276.443 399.392 273.137 399.227 269.295V269.227C399.021 261.352 397.8 247.4 396.566 245.122Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M396.661 245.276C397.855 247.512 399.103 261.272 399.323 269.38C399.515 277.008 399.734 282.592 375.548 283.237C371.638 283.346 369.703 278.147 369.552 272.769C369.415 267.171 370.842 258.871 370.924 254.454C371.199 254.317 391.229 250.105 396.661 245.276Z",
    fill: "url(#paint51_linear_164_14271)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M392.943 282.887C373.53 283.409 373.256 287.003 372.638 295.084C372.529 296.634 372.391 298.404 372.103 300.311C371.61 303.466 371.911 308.117 374.367 310.915C374.952 311.597 375.685 312.135 376.51 312.49C377.335 312.844 378.231 313.005 379.128 312.96C383.696 312.836 385.315 308.679 386.207 305.03C389.157 305.684 392.171 306.006 395.193 305.99C398.444 305.908 403.85 305.071 403.726 300.503C403.644 297.073 399.816 282.709 392.943 282.887Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M403.809 300.59C403.919 304.706 399.405 305.859 395.385 305.968C392.334 305.977 389.292 305.641 386.317 304.967C385.439 308.602 383.889 312.814 379.32 312.938C373.393 313.102 371.555 305.913 372.461 300.44C374.258 288.874 370.032 283.73 393.19 283.098C399.775 282.934 403.713 296.886 403.809 300.59Z",
    fill: "url(#paint52_linear_164_14271)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M392.504 180.364C387.551 164.19 375.808 161.075 366.822 161.322C363.508 161.412 360.222 161.952 357.054 162.927C352.417 165.671 351.456 173.903 354.186 187.169C355.58 193.688 357.413 200.105 359.674 206.376V206.376C360.264 207.172 362.761 207.597 366.191 207.515C374.134 207.295 385.301 204.428 390.611 197.047C393.876 192.561 394.507 186.936 392.504 180.364Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M357.314 163.142C357.314 163.142 384.382 153.703 392.586 180.497C400.79 207.29 362.404 209.595 359.989 206.426C359.989 206.412 346.257 169.7 357.314 163.142Z",
    fill: "url(#paint53_linear_164_14271)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M404.741 306.709C404.495 304.336 403.068 301.496 401.655 301.524H401.572C400.873 301.592 400.283 302.36 399.83 303.773C399.522 305.053 399.461 306.381 399.652 307.683C399.652 308.177 399.652 308.657 399.652 309.055C399.5 309.961 399.204 310.837 398.774 311.648C398.21 312.632 397.899 313.739 397.868 314.872C397.978 315.874 398.527 316.409 399.432 316.381H399.611C403.589 316.011 405.126 310.537 404.741 306.709Z",
    fill: "#736E86"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M400.037 309.208C399.801 307.448 399.833 305.662 400.133 303.912C400.613 302.43 401.19 301.799 401.779 301.731C403.151 301.593 404.523 304.474 404.825 306.82C405.209 310.744 403.577 316.012 399.873 316.424C399.673 316.46 399.468 316.452 399.271 316.4C399.075 316.347 398.893 316.252 398.738 316.121C398.584 315.99 398.46 315.826 398.376 315.641C398.292 315.456 398.25 315.255 398.254 315.052C398.075 313.186 399.873 311.06 400.037 309.208Z",
    fill: "url(#paint54_linear_164_14271)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M383.492 311.38C382.432 309.883 381.694 308.183 381.324 306.386C380.679 304.095 380.076 301.927 378.306 300.898C377.236 300.268 376.033 299.896 374.794 299.815H374.396C373.837 299.814 373.283 299.927 372.769 300.148C372.254 300.368 371.79 300.691 371.405 301.097C371.02 301.502 370.722 301.982 370.528 302.507C370.335 303.032 370.25 303.591 370.28 304.15C370.356 306.916 371.075 309.626 372.379 312.066C373.655 314.508 375.919 317.444 379.5 317.553C379.664 317.567 379.829 317.567 379.993 317.553C382.518 317.485 384.411 316.031 384.507 314.11C384.495 313.11 384.136 312.145 383.492 311.38V311.38Z",
    fill: "#736E86"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M383.6 311.551C384.24 312.322 384.589 313.293 384.587 314.295C384.491 316.352 382.269 317.738 379.717 317.615C373.297 317.313 370.443 307.764 370.608 304.28C370.571 303.702 370.66 303.124 370.87 302.584C371.079 302.045 371.403 301.557 371.819 301.155C372.235 300.753 372.734 300.446 373.28 300.256C373.827 300.066 374.408 299.997 374.984 300.054C376.197 300.144 377.373 300.505 378.428 301.11C381.569 302.921 381.034 308.574 383.6 311.551Z",
    fill: "url(#paint55_linear_164_14271)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M402.259 307.336C401.944 304.208 400.558 301.958 398.953 301.999H398.816C397.718 302.109 396.634 303.248 395.701 305.306C395.445 306.309 395.275 307.333 395.194 308.365C395.113 309.779 394.797 311.17 394.261 312.481C394.039 312.928 393.773 313.351 393.465 313.743C392.728 314.526 392.3 315.55 392.258 316.624C392.256 316.909 392.311 317.19 392.421 317.453C392.531 317.716 392.692 317.953 392.896 318.152C393.1 318.35 393.341 318.506 393.606 318.609C393.872 318.712 394.155 318.76 394.439 318.751H394.645C397.085 318.099 399.204 316.581 400.605 314.48C402.007 312.379 402.595 309.839 402.259 307.336V307.336Z",
    fill: "#736E86"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M396.002 305.442C397.004 303.275 398.06 302.315 399.021 302.218C400.667 302.054 402.025 304.4 402.341 307.445C402.695 309.922 402.127 312.443 400.743 314.528C399.359 316.612 397.257 318.115 394.836 318.75C394.552 318.789 394.263 318.767 393.989 318.685C393.714 318.603 393.46 318.463 393.244 318.274C393.028 318.086 392.855 317.853 392.737 317.592C392.619 317.331 392.558 317.047 392.559 316.761C392.408 315.279 393.999 313.907 394.576 312.645C395.632 310.423 395.344 307.816 396.002 305.442Z",
    fill: "url(#paint56_linear_164_14271)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M398.171 306.759C397.855 303.645 396.497 300.531 394.206 300.75C392.985 300.874 391.682 301.958 390.337 303.961C390.159 304.701 390.008 305.429 389.871 306.128C389.611 307.805 389.151 309.445 388.499 311.012C388.24 311.55 387.942 312.069 387.607 312.563C386.667 313.742 386.098 315.175 385.975 316.678C386.098 317.872 386.962 318.489 388.472 318.448H388.897C395.482 317.803 398.857 313.537 398.171 306.759Z",
    fill: "#736E86"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M390.639 304.122C392.011 301.995 393.383 301.062 394.425 300.953C396.511 300.747 397.91 303.546 398.253 306.866C398.939 313.725 395.509 317.841 389.089 318.445C387.717 318.582 386.441 318.225 386.345 316.798C386.153 314.96 388.197 312.683 388.869 311.187C389.681 308.893 390.274 306.528 390.639 304.122V304.122Z",
    fill: "url(#paint57_linear_164_14271)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M397.266 283.14C396.978 281.069 396.635 278.723 395.195 278.394H394.742C392.163 278.462 375.082 280.026 374.163 281.137C373.463 281.988 372.503 286.625 373.546 288.697C373.848 289.3 376.55 289.355 378.759 289.3C385.303 289.122 395.373 287.736 397.266 285.582C397.375 285.468 397.46 285.332 397.514 285.183C397.568 285.034 397.591 284.876 397.582 284.718C397.431 284.293 397.348 283.73 397.266 283.14Z",
    fill: "#736E86"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M373.792 288.775C374.561 290.325 397.966 288.445 397.609 284.865C397.17 282.848 397.142 278.993 395.359 278.609C394.563 278.43 375.356 280.2 374.396 281.353C373.683 282.203 372.791 286.758 373.792 288.775Z",
    fill: "url(#paint58_linear_164_14271)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M392.791 306.7C392.531 303.956 390.871 302.214 388.47 302.283H388.058C386.818 302.462 385.638 302.932 384.615 303.655C382.914 304.848 382.42 307.208 381.871 309.691C381.608 311.627 380.965 313.492 379.978 315.179C379.364 316.066 379.065 317.133 379.127 318.211C379.319 320.282 381.295 321.723 383.805 321.654H384.299C387.88 321.27 389.979 318.005 391.159 315.33C392.325 312.606 392.882 309.661 392.791 306.7Z",
    fill: "#736E86"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M380.308 315.352C379.699 316.21 379.403 317.251 379.472 318.301C379.677 320.496 381.968 321.855 384.52 321.58C390.913 320.908 393.232 310.536 392.875 306.805C392.573 303.663 390.584 302.291 388.265 302.538C387.04 302.71 385.877 303.181 384.877 303.91C381.859 305.995 382.709 311.963 380.308 315.352Z",
    fill: "url(#paint59_linear_164_14271)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M386.892 174.824C386.801 176.002 386.364 177.125 385.635 178.054C384.905 178.982 383.917 179.673 382.795 180.04C381.673 180.407 380.467 180.432 379.33 180.114C378.194 179.795 377.177 179.146 376.409 178.25C375.641 177.353 375.156 176.249 375.016 175.077C374.876 173.904 375.086 172.717 375.621 171.664C376.156 170.612 376.991 169.742 378.02 169.164C379.049 168.586 380.227 168.326 381.404 168.418C382.98 168.544 384.441 169.288 385.47 170.489C386.498 171.689 387.009 173.248 386.892 174.824V174.824Z",
    fill: "#5A2045"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M380.474 180.325C381.651 180.416 382.828 180.157 383.858 179.579C384.887 179.001 385.722 178.131 386.257 177.078C386.792 176.026 387.002 174.838 386.862 173.666C386.722 172.494 386.237 171.389 385.469 170.493C384.701 169.596 383.684 168.947 382.547 168.629C381.411 168.31 380.205 168.336 379.083 168.702C377.961 169.069 376.972 169.76 376.243 170.689C375.514 171.617 375.076 172.741 374.986 173.918C374.869 175.494 375.38 177.053 376.408 178.254C377.436 179.454 378.898 180.199 380.474 180.325V180.325ZM387.512 174.837C387.41 176.135 386.926 177.374 386.121 178.397C385.316 179.42 384.226 180.182 382.988 180.585C381.75 180.989 380.42 181.016 379.167 180.664C377.913 180.313 376.792 179.597 375.945 178.608C375.098 177.619 374.563 176.402 374.408 175.109C374.253 173.816 374.485 172.507 375.073 171.346C375.662 170.185 376.582 169.224 377.717 168.586C378.851 167.947 380.15 167.659 381.448 167.758C382.314 167.827 383.157 168.067 383.93 168.462C384.704 168.857 385.391 169.401 385.955 170.062C386.518 170.723 386.945 171.489 387.212 172.315C387.479 173.142 387.581 174.013 387.512 174.878V174.837Z",
    fill: "#DBBAD3"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M385.714 175.493C385.384 174.73 384.81 174.098 384.082 173.696C382.637 173.161 381.385 172.205 380.488 170.952C380.076 170.363 379.706 170.047 379.459 170.143C379.212 170.239 379.129 170.733 379.239 171.515C379.418 173.065 379.126 174.633 378.402 176.015C378.083 176.788 378.006 177.639 378.183 178.457C378.457 179.156 379.733 178.594 381.42 178.128L381.612 178.663L383.478 177.935L383.286 177.414C384.85 176.495 385.989 176.138 385.714 175.493Z",
    fill: "#C3A4B9"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M376.384 173.931L376.714 174.343L377.221 174.151L376.933 174.603L377.262 175.015L376.741 174.878L376.453 175.33L376.426 174.795L375.904 174.658L376.412 174.466L376.384 173.931Z",
    fill: "#E6332A"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M384.218 170.927L384.548 171.353L385.055 171.161L384.767 171.613L385.097 172.025L384.589 171.888L384.287 172.327L384.26 171.792L383.738 171.655L384.246 171.476L384.218 170.927Z",
    fill: "#E6332A"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M382.435 169.774L382.764 170.199L383.272 170.007L382.97 170.46L383.313 170.871L382.792 170.734L382.504 171.173L382.476 170.652L381.969 170.501L382.449 170.309L382.435 169.774Z",
    fill: "#E6332A"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M376.96 171.747L377.289 172.158L377.796 171.966L377.495 172.419L377.824 172.83L377.316 172.693L377.028 173.132L377.001 172.597L376.493 172.474L376.987 172.268L376.96 171.747Z",
    fill: "#E6332A"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M380.363 171.297C380.199 170.762 379.883 170.391 379.677 170.46C379.472 170.529 379.444 171.009 379.677 171.544C379.911 172.079 380.171 172.463 380.377 172.394C380.583 172.326 380.542 171.832 380.363 171.297Z",
    fill: "#5A2045"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M157.675 0H148.963V485.795L149.786 486.673H157.62L157.675 0Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M158.334 0.872009H149.636V486.653H158.334V0.872009Z",
    fill: "url(#paint60_linear_164_14271)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M150.307 7.80256C100.205 -12.6664 50.1572 28.2715 0 7.80256V80.9118C50.1023 101.381 100.15 60.4429 150.307 80.9118V7.80256Z",
    fill: "#FFFAE4"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M151.103 8.84192C101 -11.627 50.9531 29.3109 0.795898 8.84192V81.9375C50.8982 102.42 100.946 61.4823 151.103 81.9375V8.84192Z",
    fill: "url(#paint61_linear_164_14271)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M146.081 257.705C141.934 250.968 139.837 243.169 140.045 235.26C139.97 229.267 141.251 223.335 143.79 217.906L143.927 217.645L143.653 217.741C139.965 218.844 136.465 220.495 133.268 222.639C129.975 225.78 128.425 231.062 128.356 234.917C128.233 241.338 128.576 250.42 133.117 255.085C134.197 256.155 135.484 256.992 136.9 257.547C138.315 258.101 139.829 258.36 141.348 258.309H141.472C142.98 258.28 144.484 258.142 145.972 257.897H146.15L146.081 257.705Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M162.393 234.81C161.243 234.88 160.103 235.069 158.991 235.372C157.56 235.752 156.093 235.977 154.614 236.045H154.546C153.694 236.06 152.849 235.882 152.076 235.523L151.665 235.345L152.419 234.892C154.179 234.013 156.047 233.372 157.975 232.985C162.27 231.888 166.701 230.763 166.728 226.935C166.76 226.57 166.718 226.202 166.605 225.853C166.491 225.505 166.31 225.182 166.07 224.905C165.614 224.529 165.088 224.248 164.523 224.076C163.958 223.904 163.365 223.845 162.777 223.903H162.667C160.489 223.98 158.33 224.344 156.247 224.987C154.875 225.33 153.338 225.728 151.377 226.139L151.185 225.248L152.255 225.014C156.562 224.027 165.562 221.983 165.576 218.745C165.576 217.195 165 215.109 159.759 215.082H159.471C154.103 215.167 148.779 216.065 143.68 217.743V217.743C141.128 223.209 139.835 229.176 139.894 235.208C139.654 243.165 141.732 251.02 145.875 257.817H145.958C153.284 256.651 164.218 253.002 164.259 247.665C164.296 247.252 164.251 246.835 164.126 246.44C164.001 246.044 163.799 245.677 163.532 245.36C163.193 245.077 162.802 244.864 162.38 244.734C161.958 244.605 161.515 244.561 161.076 244.605C160.199 244.63 159.324 244.704 158.456 244.825C157.4 244.97 156.338 245.052 155.273 245.072H155.177C154.386 245.078 153.6 244.962 152.845 244.729L152.433 244.619L153.201 244.057C154.646 243.317 156.189 242.786 157.783 242.479C161.721 241.45 166.18 240.284 166.207 237.307C166.262 235.935 164.574 234.824 162.393 234.81Z",
    fill: "#9390A2"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M143.873 217.944C140.209 219.054 136.729 220.695 133.542 222.815C130.474 226.143 128.74 230.485 128.672 235.011C128.439 246.494 130.044 258.183 141.568 258.334C143.108 258.311 144.644 258.173 146.164 257.922C142.019 251.158 139.918 243.34 140.114 235.409C140.027 229.378 141.312 223.406 143.873 217.944V217.944Z",
    fill: "url(#paint62_radial_164_14271)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M162.586 235.026C160.555 235.026 157.4 236.288 154.725 236.261C153.623 236.238 152.541 235.971 151.556 235.479L152.516 234.875C156.632 232.365 166.729 232.667 166.77 227.028C166.77 225.656 166.358 224.133 162.942 224.12C159.526 224.106 157.167 225.176 151.446 226.369L151.213 225.258C154.629 224.435 165.604 222.309 165.631 218.838C165.631 217.342 165.069 215.326 159.91 215.284C154.46 215.352 149.052 216.249 143.873 217.946C141.32 223.39 140.035 229.343 140.114 235.356C139.929 243.268 142.03 251.065 146.164 257.814C153.696 256.634 164.328 252.957 164.369 247.785C164.369 243.217 159.705 245.343 155.411 245.316C154.38 245.288 153.359 245.112 152.379 244.794L153.366 244.081C155.932 242.256 166.29 241.79 166.317 237.427C166.331 236.096 164.726 235.04 162.586 235.026Z",
    fill: "url(#paint63_radial_164_14271)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2184 48.1815C29.5384 50.8568 30.8692 51.0488 32.9407 53.2713C35.6846 56.3307 35.1907 65.0972 26.8906 61.1461C24.671 60.0473 22.6788 58.5392 21.0188 56.7011C20.7856 55.4664 20.5386 54.218 20.3054 52.9832C23.0492 56.9618 29.6619 61.7909 29.703 56.7972C29.6207 52.0229 19.9624 50.747 19.8115 42.6802C19.8801 39.7305 21.9929 39.9363 26.1223 41.8158C33.709 45.6435 32.3371 43.7091 33.5718 48.401C31.1323 46.5143 28.3302 45.1507 25.3403 44.395C24.284 44.3127 23.7215 46.1648 26.2184 48.1815Z",
    fill: "#84160E"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4489 61.712C44.2647 61.6928 45.052 61.4077 45.6909 60.9C46.3298 60.3924 46.7854 59.69 46.9884 58.8996L46.7415 45.3588C47.8939 45.2216 49.06 45.0432 50.2261 44.8237L50.5554 63.468C49.403 63.6875 48.2369 63.8659 47.0845 64.0031V62.2745C46.2089 63.0205 45.1946 63.5862 44.0999 63.9394C43.0052 64.2925 41.8515 64.4261 40.7051 64.3323C34.4903 63.8385 36.0543 55.7304 35.8622 45.1256C37.4138 45.385 38.9816 45.5363 40.5542 45.5783C40.7325 57.6374 39.9094 61.8217 43.4489 61.712Z",
    fill: "#84160E"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6254 60.8072C59.1076 61.4367 57.4412 61.6177 55.8237 61.3285C51.4747 60.1898 50.8711 48.4462 55.4395 44.5088C57.6602 42.8665 60.261 41.814 62.9988 41.4495C65.5094 41.0791 64.9058 40.7498 65.5506 43.6994C63.9638 43.5653 62.3669 43.7807 60.8723 44.3305C55.7825 46.0729 56.8389 54.4964 57.7855 57.0207C59.2398 61.0267 65.8112 55.4567 65.7975 54.9903C65.6191 57.5969 66.8127 58.5161 60.6254 60.8072Z",
    fill: "#84160E"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M75.18 55.1696C73.6876 55.8973 72.0373 56.2415 70.3783 56.171C64.8907 55.4165 63.5188 36.5664 79.5564 35.3728L80.0915 37.8834C77.869 37.4444 73.3828 38.6791 72.299 41.7248C71.3336 44.9559 71.3336 48.3988 72.299 51.63C73.6709 55.293 80.3247 49.627 80.311 49.1606C80.0778 52.9608 81.1616 52.5492 75.18 55.1696Z",
    fill: "#84160E"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8686 42.5713C86.1156 45.1779 87.2405 48.059 89.7374 47.4553C91.9791 46.9026 94.0076 45.6998 95.568 43.9981C94.7998 48.0178 95.2251 47.4965 93.4965 48.4705C91.4249 49.6641 85.4845 51.7631 83.1385 49.8424C80.3947 47.565 79.352 34.2849 88.6262 31.2942C94.6351 29.4284 96.7204 33.5989 96.0619 39.7863C92.6052 40.4833 89.1996 41.4138 85.8686 42.5713V42.5713ZM85.8686 40.1018C88.2557 39.2604 90.652 38.5379 93.0574 37.9342C92.8654 30.4299 85.6766 32.4328 85.8275 40.1018H85.8686Z",
    fill: "#84160E"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M103.292 34.7516C106.393 35.6159 108.231 35.9726 109.973 37.6601C112.086 39.7179 111.812 44.5197 109.877 45.9876C107.422 47.922 100.823 47.7299 98.1613 47.0577L97.4616 43.9023C99.6292 45.2056 106.722 46.3169 106.749 41.9267C106.64 36.1647 97.1461 41.0487 96.9814 33.8873C97.1186 27.8097 105.83 27.1924 109.768 29.5795C110.042 30.6085 110.33 31.6648 110.605 32.7075C109.454 31.8444 108.111 31.2747 106.691 31.0476C105.271 30.8205 103.817 30.9429 102.455 31.4041C102.158 31.6236 101.932 31.9265 101.807 32.2744C101.682 32.6222 101.663 32.9995 101.753 33.3581C101.843 33.7167 102.037 34.0407 102.311 34.2888C102.585 34.5369 102.926 34.698 103.292 34.7516Z",
    fill: "#84160E"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M118.849 37.5552C120.001 38.4058 121.195 39.3249 122.402 40.299C128.548 45.3065 127.602 51.5624 125.489 52.0289C123.376 52.4953 117.257 49.4771 115.886 48.6951C113.142 47.186 113.869 48.1464 113.018 44.0581C114.623 45.6358 122.361 50.8216 122.388 46.3492C122.279 40.299 112.662 41.0261 112.538 33.9196C112.675 28.432 119.686 30.5859 123.513 33.9196C125.777 35.8814 125.283 35.2915 126.257 39.3112C124.474 36.8006 120.289 33.6864 118.026 33.8236C116.997 33.9059 116.256 35.6482 118.849 37.5552Z",
    fill: "#84160E"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3932 47.7586C28.7132 50.4339 30.044 50.6259 32.1018 52.8621C34.9142 55.9078 34.3655 64.6743 26.0517 60.7369C23.835 59.6334 21.8437 58.1259 20.1799 56.2919L19.4802 52.5603C22.224 56.5526 28.8367 61.3817 28.8641 56.3879C28.7818 51.6137 19.1235 50.3378 18.9863 42.271C19.0549 39.3076 21.1677 39.5271 25.2971 41.4067C32.8838 45.2343 31.5119 43.2999 32.7329 47.9781C30.2924 46.0931 27.4906 44.7296 24.5014 43.9721C23.445 43.9035 22.8826 45.7419 25.3932 47.7586Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6124 61.2823C43.4204 61.2718 44.203 60.9983 44.8416 60.5032C45.4803 60.0081 45.9402 59.3184 46.1519 58.5385L45.9049 44.9977C47.0711 44.8605 48.2235 44.6822 49.3896 44.4626C49.4993 50.682 49.6137 56.8968 49.7326 63.107C48.5664 63.3265 47.414 63.5048 46.2479 63.642C46.2479 63.0521 46.2479 62.4759 46.2479 61.8997C45.3731 62.6513 44.3569 63.2205 43.2591 63.5739C42.1612 63.9272 41.0038 64.0577 39.8548 63.9576C33.6537 63.4637 35.204 55.3694 35.0119 44.7508C36.5752 44.984 38.1513 45.1215 39.7313 45.1623C39.896 57.2215 39.0728 61.4058 42.6124 61.2823Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8006 60.3844C58.2765 61.0077 56.6074 61.1884 54.9852 60.9058C50.6362 59.7671 50.0463 48.0235 54.6148 44.0861C56.8292 42.4417 59.426 41.3888 62.1603 41.0267C64.6846 40.6563 64.0673 40.327 64.7121 43.2767C63.1298 43.1419 61.5372 43.3573 60.0476 43.9077C54.944 45.6501 56.0141 54.0736 56.947 56.5842C58.4013 60.5902 64.9864 55.0202 64.9727 54.5538C64.7807 57.1741 65.988 58.0933 59.8006 60.3844Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3441 54.7731C72.8518 55.5001 71.2005 55.8398 69.5424 55.7609C64.0547 55.0201 62.6828 36.17 78.7205 34.9764C78.8988 35.8133 79.0772 36.6502 79.2693 37.4733C77.0331 37.048 72.5606 38.2828 71.4631 41.3284C70.4972 44.5548 70.4972 47.9935 71.4631 51.2199C72.835 54.8966 79.4888 49.2306 79.4751 48.7642C79.2418 52.5506 80.3256 52.1391 74.3441 54.7731Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0033 42.1475C85.2503 44.7678 86.3753 47.6351 88.8859 47.0315C91.1304 46.4951 93.1589 45.2895 94.7028 43.5743C93.9482 47.594 94.3598 47.0726 92.6312 48.0604C90.5733 49.254 84.6329 51.353 82.2732 49.4323C79.5294 47.155 78.5005 33.8749 87.7609 30.8978C93.7699 29.032 95.8552 33.2026 95.1966 39.39C91.7402 40.0766 88.3345 40.9978 85.0033 42.1475ZM85.0033 39.678C87.4042 38.8549 89.7913 38.1141 92.1922 37.5241C92.0413 30.0746 84.8524 32.009 85.0033 39.678Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M102.454 34.3387C105.569 35.203 107.393 35.5598 109.136 37.2472C111.262 39.2914 110.974 44.0382 109.04 45.561C106.584 47.5091 99.9849 47.317 97.3371 46.6448C97.1039 45.5884 96.8707 44.5458 96.6237 43.4894C98.8051 44.8613 105.898 45.904 105.912 41.5139C105.802 35.7518 96.3082 40.6358 96.1436 33.4745C96.2807 27.3969 104.992 26.7658 108.93 29.1529C109.218 30.1955 109.492 31.2382 109.78 32.2946C108.63 31.4316 107.287 30.8618 105.867 30.6348C104.447 30.4077 102.993 30.53 101.631 30.9913C101.328 31.2062 101.096 31.5075 100.966 31.856C100.836 32.2046 100.814 32.5842 100.902 32.9454C100.991 33.3067 101.187 33.6328 101.464 33.8813C101.74 34.1298 102.086 34.2892 102.454 34.3387V34.3387Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M118.012 37.1451C119.164 37.9957 120.358 38.9149 121.579 39.889C127.711 44.9102 126.765 51.1661 124.652 51.6325C122.539 52.099 116.421 49.0808 115.049 48.2988C112.305 46.7897 113.046 47.75 112.195 43.6617C113.8 45.2394 121.538 50.4115 121.565 45.9528C121.455 39.9026 111.838 40.6298 111.701 33.5233C111.838 28.0356 118.863 30.1895 122.676 33.5233C124.94 35.4851 124.46 34.8952 125.42 38.9012C123.623 36.4043 119.439 33.29 117.189 33.4135C116.174 33.4821 115.419 35.2244 118.012 37.1451Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_164_14271",
    x: 229.879,
    y: 38,
    width: 132,
    height: 132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_14271"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_164_14271",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_164_14271",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(248.962 206.844) scale(154.587 157.679)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FBFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F2F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DAD8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#B3AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAA6AC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_164_14271",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(229.041 150.313) scale(3.7316)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#838BA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#797E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#61607B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#524E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#4D4765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#262843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C26"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_164_14271",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2439.38 902.968) scale(21.6433 18.77)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#838BA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#797E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#61607B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#524E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#4D4765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#262843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C26"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_164_14271",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18060.3 29468.7) scale(1856.48 2042.75)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#838BA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#797E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#61607B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#524E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#4D4765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#262843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_164_14271",
    x1: 265.379,
    y1: 375.996,
    x2: 287.879,
    y2: 375.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_164_14271",
    x1: 22649,
    y1: 20699.3,
    x2: 26526,
    y2: 20699.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FBFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F2F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DAD8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#B3AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAA6AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_164_14271",
    x1: 229.618,
    y1: 411.259,
    x2: 286.237,
    y2: 411.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4D4765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#262843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1C1C26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_164_14271",
    x1: 17844,
    y1: 12804.4,
    x2: 20066.6,
    y2: 12804.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4D4765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#262843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1C1C26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_164_14271",
    x1: 4927.89,
    y1: 6797.26,
    x2: 5441.56,
    y2: 6797.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4D4765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#262843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1C1C26"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_164_14271",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(359.99 313.798) rotate(180) scale(45.479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#4D4765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#262843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_164_14271",
    x1: 303.879,
    y1: 384.996,
    x2: 359.879,
    y2: 384.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_164_14271",
    x1: -19514,
    y1: 20699.3,
    x2: -23399,
    y2: 20699.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FBFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F2F1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DAD8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#B3AFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAA6AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_164_14271",
    x1: -15679.3,
    y1: 17817.1,
    x2: -18026.7,
    y2: 17817.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4D4765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#262843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1C1C26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_164_14271",
    x1: -15356.7,
    y1: 12804.4,
    x2: -17587,
    y2: 12804.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4D4765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#262843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1C1C26"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_164_14271",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12871.2 17332.6) scale(325.779 303.179)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#1F1F1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#272725"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#343432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#464644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#5E5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#7B7B7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#9E9E9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#C7C7C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_164_14271",
    x1: 348.246,
    y1: 376.807,
    x2: 321.658,
    y2: 376.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1C1C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#262843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#4D4765"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_164_14271",
    x1: -6432.73,
    y1: 10692.4,
    x2: -6828.74,
    y2: 10692.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#F7F6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#EDEBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E7E4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E5E2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E3E0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDD9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D1CCD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C1BBC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAB3BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_164_14271",
    x1: 323.879,
    y1: 376.809,
    x2: 347.147,
    y2: 376.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#F7F6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#EDEBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E7E4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E5E2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E3E0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDD9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D1CCD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C1BBC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAB3BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_164_14271",
    x1: 230.742,
    y1: 224.361,
    x2: 360.58,
    y2: 224.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F2F0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ECE9ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EAE7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E8E5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#E1DEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D5D1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#C3C0C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAA6AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_164_14271",
    x1: 290.64,
    y1: 234.452,
    x2: 301.231,
    y2: 234.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#EEECEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E2E1E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DCDADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DAD8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D8D6DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#D1CFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#C5C2C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B4B1B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAA6AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_164_14271",
    x1: 295.763,
    y1: 294.521,
    x2: 295.763,
    y2: 346.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_164_14271",
    x1: 359.879,
    y1: 298.998,
    x2: 305.379,
    y2: 298.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_164_14271",
    x1: 295.674,
    y1: 296.34,
    x2: 295.674,
    y2: 282.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#FAF9FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_164_14271",
    x1: 359,
    y1: 289.437,
    x2: 278,
    y2: 289.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_164_14271",
    x1: 244.379,
    y1: 234.035,
    x2: 342.841,
    y2: 234.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#F8F7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#EEECEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E8E5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E6E3E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E4E1E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DEDADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2CDD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C2BCC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCB5BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_164_14271",
    x1: 337.5,
    y1: 230.438,
    x2: 335,
    y2: 230.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_164_14271",
    x1: 1989.25,
    y1: 22327.7,
    x2: 2059.18,
    y2: 22327.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#F7F6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#EDEBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E7E4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E5E2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E3E0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDD9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D1CCD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C1BBC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAB3BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_164_14271",
    x1: 242.87,
    y1: 229.979,
    x2: 255.657,
    y2: 229.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F8F7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F2F0F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F0EEF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#EEECF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#E8E5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#DDD8E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D0DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_164_14271",
    x1: 295.647,
    y1: 280.657,
    x2: 295.647,
    y2: 304.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_164_14271",
    x1: 313.879,
    y1: 286.104,
    x2: 291.379,
    y2: 308.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_164_14271",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(296.563 148.003) rotate(90) scale(33 123.475)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_164_14271",
    x1: 353.879,
    y1: 180.743,
    x2: 296.563,
    y2: 180.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_164_14271",
    x1: 356.394,
    y1: 81.1215,
    x2: 356.394,
    y2: 135.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_164_14271",
    x1: 235.128,
    y1: 81.1215,
    x2: 235.128,
    y2: 135.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_164_14271",
    x1: 226.879,
    y1: 69.999,
    x2: 234.879,
    y2: 69.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_164_14271",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(232.745 54.7539) scale(8.60192 9.29004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#848DA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#797E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#61607D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#534E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#4E4767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#262945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_164_14271",
    x1: 230,
    y1: 90.4351,
    x2: 362,
    y2: 97.4351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_164_14271",
    x1: 295.709,
    y1: 21.6147,
    x2: 295.709,
    y2: 37.1997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_164_14271",
    x1: 287.087,
    y1: 29.3844,
    x2: 304.387,
    y2: 29.3844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1C28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#262945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4E4767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#534E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#61607D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#797E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#848DA3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_164_14271",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1563.58 70644.4) rotate(14.226) scale(543.053 1409.92)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#1F1F1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#272725"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#343432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#464644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#5E5E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#7B7B7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#9E9E9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#C7C7C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_164_14271",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(275.261 211.383) scale(8.99976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E3B6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#DAABC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C693AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B98498"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#B57F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#933877"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#702A5D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_164_14271",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3687.64 3777.84) scale(29.4293 29.4292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#838BA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#797E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#61607B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#524E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#4D4765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#262843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C26"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_164_14271",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(312.427 224.1) scale(4.48615)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#BCDDC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#9EC5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8CB5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#85B0AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#3B8B5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D6B40"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_164_14271",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11592.5 18509.8) rotate(0.44) scale(605.072 675.466)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#838BA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#797E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#61607B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#524E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#4D4765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#262843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_164_14271",
    x1: 5280.54,
    y1: 5846.04,
    x2: 5579.63,
    y2: 5848.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#1C1C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#262843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#4D4765"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_164_14271",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11216.2 15295.8) rotate(0.44) scale(496.258 527.154)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#838BA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#797E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#61607B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#524E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#4D4765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#262843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1C26"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_164_14271",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12043.2 24611.8) rotate(0.44) scale(1199.56 1763.31)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#FBFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E3E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_164_14271",
    x1: 141.304,
    y1: 238.806,
    x2: 197.701,
    y2: 239.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FBFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#F9F8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F3F1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E7E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#D7D5D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#C2BFC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAA6AC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_164_14271",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(213.879 175.502) rotate(73.3008) scale(57.4217 54.3584)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_164_14271",
    x1: 359.274,
    y1: 235.697,
    x2: 395.85,
    y2: 234.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#262843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4D4765"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_164_14271",
    x1: 382.379,
    y1: 230.847,
    x2: 396.879,
    y2: 230.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_164_14271",
    x1: 384.879,
    y1: 264.002,
    x2: 400.379,
    y2: 264.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_164_14271",
    x1: 387.879,
    y1: 296.003,
    x2: 403.879,
    y2: 296.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_164_14271",
    x1: 373.371,
    y1: 161.529,
    x2: 395.379,
    y2: 161.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_164_14271",
    x1: 4001.5,
    y1: 6976.25,
    x2: 4036.9,
    y2: 6972.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4D4765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#262843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1C1C26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_164_14271",
    x1: -4984.38,
    y1: 8308.28,
    x2: -5131.67,
    y2: 8300.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4D4765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#262843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1C1C26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_164_14271",
    x1: 5464.28,
    y1: 7721.4,
    x2: 5540.77,
    y2: 7713.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4D4765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#262843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1C1C26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_164_14271",
    x1: 6361.38,
    y1: 8078.34,
    x2: 6473.68,
    y2: 8066.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4D4765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#262843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1C1C26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_164_14271",
    x1: 10726.8,
    y1: 4875.45,
    x2: 11156.4,
    y2: 4863.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4D4765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#262843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1C1C26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_164_14271",
    x1: 6981.34,
    y1: 8796.68,
    x2: 7122.76,
    y2: 8782.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4D4765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#262843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1C1C26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_164_14271",
    x1: 159.379,
    y1: 325.997,
    x2: 149.879,
    y2: 325.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_164_14271",
    x1: 0.795898,
    y1: 45.3897,
    x2: 151.103,
    y2: 45.3897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#D11E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E63441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#AB3538"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_164_14271",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4247.03 17033.5) rotate(0.440001) scale(448.666 1034.77)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FBFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_164_14271",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6685.32 17835.6) rotate(0.44) scale(740.289 1180.61)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4D4765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#262843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1C1C26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstronaut);
export default __webpack_public_path__ + "static/media/astronaut.3d9ba3a3907f3d6e17c44e081fd16c24.svg";
export { ForwardRef as ReactComponent };